module.exports = __webpack_public_path__ + "static/SimpleLineIcons-d2285965fe34b05465047401b8595dd0.ttf";